import React from "react";
import { IconProps } from "../icon";
import { createIcon } from "../util/create-icon";
// import "../style/css";

const ErrorCircleIcon: React.ForwardRefExoticComponent<
  IconProps & React.RefAttributes<SVGSVGElement>
> = /*#__PURE__*/ createIcon(
  "error-circle",
  "ErrorCircleIcon",
  ["currentColor","white"],
  (colorList) => <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16"><g fill="none"><g clipPath="url(#clip0_19498_602)"><path d="M8.00016 2.00002C11.3139 2.00002 14.0002 4.68631 14.0002 8.00002C14.0002 11.3137 11.3139 14 8.00016 14C4.68646 14 2.00016 11.3137 2.00016 8.00002C2.00016 4.68631 4.68645 2.00002 8.00016 2.00002ZM15.3335 8.00002C15.3335 3.94993 12.0503 0.666687 8.00016 0.666688C3.95008 0.666688 0.66683 3.94993 0.666831 8.00002C0.666831 12.0501 3.95008 15.3334 8.00016 15.3334C12.0503 15.3334 15.3335 12.0501 15.3335 8.00002ZM7.3335 4.33335L7.3335 9.33335L8.66683 9.33335L8.66683 4.33335L7.3335 4.33335ZM8.66683 10.3334L7.33089 10.3334L7.33089 11.6693L8.66683 11.6693L8.66683 10.3334Z" fill={colorList[0]} fillRule="evenodd" clipRule="evenodd" fillOpacity="0.9"/></g><defs><clipPath id="clip0_19498_602"><rect width="16" height="16" fill={colorList[1]}/></clipPath></defs></g></svg>
);

export default ErrorCircleIcon;
